define('home/views/TopicInputView',[
    'underscore',
    'backbone-marionette',

    'home/models/Topic',

    'home/templates/topicInput',

    'home/views/TopicTagView',
], function (
    _,
    Marionette,

    Topic,

    topicInputTemplate,

    TopicTagView
) {
    'use strict';

    var TopicInputView = Marionette.CompositeView.extend({
        className: 'topic-group__wrapper',
        template: topicInputTemplate,
        itemView: TopicTagView,
        itemViewContainer: '[data-role=topics]',

        initialize: function () {
            this.listenTo(this, 'itemview:removeTag', this.handleRemoveTopicByTag);
        },

        events: {
            'keydown [name=topics]': 'handleTopicInputKeydown',
            'blur input[name=topics]': 'handleTopicInputBlur',
        },

        ui: {
            topics: '[name=topics]',
        },

        handleTopicInputKeydown: function (evt) {
            if (_.contains(TopicInputView.TOPIC_INSERTION_KEYS, evt.keyCode) && !evt.shiftKey) {
                // User pressed a key used to insert a topic. Prevent the user from
                // entering that character and then parse the typed topic.
                evt.preventDefault();
                this.parseTopicInput();
            } else if (evt.keyCode === 8) {
                // This allows the user to remove the last non-hidden topic by typing backspace
                // if there's no text in the input field.
                var inputLength = this.ui.topics.val().length;
                if (!inputLength) {
                    var lastTopic = _.last(this.collection.filter(function (topic) {
                        return !topic.get('hidden');
                    }));
                    if (lastTopic)
                        this.collection.remove(lastTopic);
                }
            }
        },

        handleTopicInputBlur: function () {
            this.parseTopicInput();
        },

        parseTopicInput: function () {
            var inputValue = this.ui.topics.val();
            if (inputValue) {
                // Split the input by comma to cover the case where a user pastes in
                // a comma-separated list of topic names. However, in most cases this
                // will only be a single value because we prevent the user from typing
                // commas individually and execute this function without it.
                var topicNames = inputValue.split(',');
                _.each(topicNames, function (topicName) {
                    var topic = Topic.getOrCreateTopic(topicName);
                    if (topic)
                        this.collection.add(topic);
                }, this);
                this.clearTopicInput();
            }
        },

        clearTopicInput: function () {
            this.ui.topics.val('');
        },

        handleRemoveTopicByTag: function (topicItemView) {
            this.collection.remove(topicItemView.model);
        },

    }, {

        TOPIC_INSERTION_KEYS: [
            9, // tab
            188, // comma
            13, // enter
            186, // semicolon
        ],

    });

    return TopicInputView;
});

